module.exports = __webpack_public_path__ + "img/6.85129601.jpg";